import { render, staticRenderFns } from "./DartBoard.vue?vue&type=template&id=317e2b12&scoped=true&"
import script from "./DartBoard.vue?vue&type=script&lang=ts&"
export * from "./DartBoard.vue?vue&type=script&lang=ts&"
import style0 from "./DartBoard.vue?vue&type=style&index=0&id=317e2b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e2b12",
  null
  
)

export default component.exports